<script setup lang="ts">

import LGReviewCarousel from "~/components/partials/LGReviewCarousel.vue";
</script>

<template>
    <section class="pt-12 pb-24 sm:pt-0 sm:pb-36 relative">
        <NuxtImg src="/images/home-page/review-map.svg" alt="Pin" class="sm:hidden h-[285px] w-auto absolute top-0 right-0" />
        <LGReviewCarousel/>
    </section>
</template>

<style scoped>

</style>
